import { Row, Typography, Form, Select, FormInstance } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  dynamicSet,
  getMyOrganization,
  getSubjectList,
  getSubjectListClear,
  getSubjectListRequest,
  useDynamicSelector,
} from "@src/redux";

import DynamicTreeSelect from "../../common/TreeSelect";
import { startCase } from "lodash";
import DynamicOrgFilter from "./DynamicOrgFilter";

interface Props {
  setLastOrgId?: (id: string) => void;
  form: FormInstance;
}
const BulkUploadFilter: React.FC<Props> = (props) => {
  const { setLastOrgId ,form} = props;
  const dispatch = useDispatch<AppDispatch>();

  // const [form] = Form.useForm();
  const search = Form.useWatch("search", form);
  const status = Form.useWatch("status", form);
  const myOrg = Form.useWatch("my_org", form);
  const [showTitle, setShowTitle] = useState<boolean>(false);

  useEffect(() => {
    let getId = myOrg;

    const fetchData = async () => {
      if (getId) {
        dispatch(
          dynamicSet("subject_filter", {
            filter: {
              searchString: search,
              status: startCase(status),
              organizationId: getId,
            },
          })
        );

        dispatch(
          getSubjectListRequest({
            filter: {
              searchString: search,
              status: startCase(status),
              organizationId: getId,
            },
            pagination: {
              pageLimit: 10,
              pageNumber: 1,
            },
            sort: [{ field: "name", order: "asc" }],
          })
        );
      }
    };

    if (getId) {
      fetchData();
    }
  }, [myOrg, status, search]);

  useEffect(() => {
    dispatch(getSubjectListClear());
    form.resetFields();
  }, []);
  return (
    <div className="filter-container">
      <div>
        {/* <Form layout="vertical" className="common-filters" form={form}> */}
          <Row gutter={24}>
            <DynamicOrgFilter
              form={form}
              col={8}
              mutationType="add"
              isRequired={true}
              allowClear={false}
              className="test"
              setLastOrgId={setLastOrgId}
            />
          </Row>
        {/* </Form> */}
      </div>
    </div>
  );
};

export default BulkUploadFilter;
